export default {
  normal: 'NORMAL',
  currentResult: 'Current recognition results: '
}
